export default
{
	metaInfo()
	{
		return {
			title: this.title,
		}
	},
}